var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterRtr(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 570,
    height: 185,
    viewBox: "0 0 570 185",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Footer-RTR_svg__clip0_29_2367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.246 60.14C145.246 24.728 120.225 0 84.829 0H0v184.695h34.786V119.67h35.701l43.025 65.025h39.058l-44.551-67.773c21.665-7.937 37.227-31.138 37.227-56.782zM83.303 86.394H34.481V32.97h49.737c17.393 0 25.327 14.349 25.327 27.78 0 15.875-10.07 25.644-26.242 25.644zM197.73 32.97h62.554v151.725h34.48V32.97h62.249V0H197.73v32.97zM525.45 116.922c21.665-7.937 37.227-31.138 37.227-56.782C562.677 24.728 537.96 0 502.259 0H417.43v184.695h34.786V119.67h35.702l43.024 65.025H570l-44.55-67.773zm-24.717-30.528h-48.822V32.97h49.738c17.393 0 25.326 14.349 25.326 27.78 0 15.875-10.069 25.644-26.242 25.644z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Footer-RTR_svg__clip0_29_2367"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h570v185H0z"
  })))));
}
export default SvgFooterRtr;